module.exports = __webpack_public_path__ + "static/point-o-woods.4006935c.jpg";